import React from 'react'
import { withStyles, Typography } from '@material-ui/core';
import PropTypes from 'prop-types';

const style = theme => ({
	root: {
		backgroundColor: theme.palette.background.greyBackground,
		width: '100%',
		height: 100,
		border: `${theme.palette.common.document} dashed 2px`,
		borderRadius: theme.shape.borderRadius,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center'
	}
})

function GreyBox({
	classes,
	children,
}) {
	const childrenComponent = () => {
		if(typeof children === 'string'){
			return (
				<Typography variant='body1'>
					{children}
				</Typography>
			)
		}
		return children;
	}

	return (
		<div className={classes.root}>
			{childrenComponent()}
		</div>
	)
}

GreyBox.propTypes = {
	classes: PropTypes.any,
}

GreyBox.defaultProps = {
}

export default withStyles(style)(GreyBox);